"use client";

import { useClientOnly } from "@/hooks";
import ScreenLoader from "./ScreenLoader";

interface ClientOnlyWrapperProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const ClientOnlyWrapper = ({
  children,
  fallback = <ScreenLoader fullScreen />,
}: ClientOnlyWrapperProps) => {
  const isClient = useClientOnly();

  if (!isClient) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
